import { ExternalLinkIcon } from "@chakra-ui/icons";
import { Link, useToast } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { SubmitFunction } from "@nens/ranalib";

import { useSubmitSchematisation } from "../api/submit-schematisation";
import { SubmitSchematisationArgs } from "../types/submit-model-schema-args";

export const useSubmitModelSchemaCatalogue = ({
  fileId,
  onCloseAll,
}: {
  fileId: string;
  onCloseAll: () => void;
}) => {
  const intl = useIntl();
  const toast = useToast();
  const { isMutating, errors, mutate } = useSubmitSchematisation();

  const submitToCatalogue = async (
    values: SubmitSchematisationArgs,
    onError?: Parameters<SubmitFunction<SubmitSchematisationArgs>>[1]
  ) => {
    const isUpdate = "schematisationId" in values;

    mutate(
      {
        path: fileId,
        ...values,
      },
      {
        onSuccess: (catalogSchematisation) => {
          onCloseAll();
          toast({
            status: "success",
            title: intl.formatMessage({ id: "success", defaultMessage: "Success!" }),
            description: (
              <>
                {isUpdate
                  ? intl.formatMessage({
                      id: "projectfile.submit.update.success",
                      defaultMessage:
                        "The model schematisation has been successfully updated in the catalogue",
                    })
                  : intl.formatMessage({
                      id: "projectfile.submit.success",
                      defaultMessage:
                        "The model schematisation has been successfully added to the catalogue",
                    })}
                <br />
                <Link
                  href={`/hcc-management/schematisations/${catalogSchematisation.id}`}
                  isExternal
                >
                  {intl.formatMessage({
                    id: "projectfile.submit.success.link",
                    defaultMessage: "View in HCC management",
                  })}
                  <ExternalLinkIcon ml={1} mb={1} />
                </Link>
              </>
            ),
          });
        },
        onError,
      }
    );
  };
  return { submitToCatalogue, isMutating, errors };
};
